import { useLayoutEffect, useState } from 'react';

export interface WindowSize {
  width: number;
  height: number;
}

function useWindowSize() {
  const [size, setSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const handleResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });

  useLayoutEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { size, handleResize };
}

export default useWindowSize;
